import { faGear } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslator } from '@/hooks/useTranslator';
import { OrdersLayout } from '../../-components/OrdersLayout';
import { useOrdersTranslator } from '../../-hooks/useOrdersTranslator';

function OrdersLayoutPage() {
  const { getTranslation: t } = useOrdersTranslator();
  const { getTranslation: tShared } = useTranslator({ page: 'shared' });

  const tabs = [
    {
      key: 'sales-orders',
      label: t('tabs.salesOrders'),
      to: '/orders/sales-orders',
    },
    {
      key: 'purchase-orders',
      label: t('tabs.purchaseOrders'),
      to: '/orders/purchase-orders',
    },
    {
      key: 'internal-orders',
      label: t('tabs.internalOrders'),
      to: '/orders/internal-orders',
    },
  ];

  const preferences = (
    <Link
      to='/orders/attachment-templates'
      className='inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium text-foreground/80 hover:bg-accent hover:text-foreground transition-colors'
    >
      <FontAwesomeIcon icon={faGear} className='size-3.5 shrink-0' />
      {t('list.preferences')}
    </Link>
  );

  return (
    <OrdersLayout
      tabs={tabs}
      moreLabel={tShared('moreTabs')}
      endContent={preferences}
    />
  );
}

export const Route = createFileRoute('/(client)/orders/(pages)/(list)')({
  component: OrdersLayoutPage,
});
